import { Stack } from "@mui/material";
import { Icon } from "components";
import { IconName } from "components/Icon";
import { cn } from "utils/styling";

import { statusMapping } from "../lib/configs";
import { ExecutionStatus } from "../model/types";

const STATUS_ICON_NAME: Record<ExecutionStatus, IconName> = {
  completed: "Checkmark",
  done: "Checkmark",
  error: "Close",
  failed: "Close",
  pending: "Calendar",
  processing: "Gears",
  queued: "Calendar",
  running: "Gears",
  waiting: "Calendar",
} as const;

const FALLBACK_ICON_NAME = "Calendar";

const EXECUTION_STEP_ICON_STYLES = {
  error: {
    iconBgClassName: "border-lds-purpose-status-negative-subtle bg-white",
    iconColor: "var(--color-purpose-status-negative-subtle)",
  },
  pending: {
    iconBgClassName: "border-lds-purpose-status-neutral-subtle bg-white",
    iconColor: "var(--color-purpose-status-neutral-subtle)",
  },
  processing: {
    iconBgClassName: "border-core-secondary-blue-700 bg-white",
    iconColor: "var(--core-color-secondary-blue-700)",
  },
  success: {
    iconBgClassName: "border-lds-purpose-status-positive bg-white",
    iconColor: "var(--color-purpose-status-positive)",
  },
};

const FALLBACK_STYLE = EXECUTION_STEP_ICON_STYLES.pending;

export const ExecutionStatusIcon = ({ status = "pending" }: { status: ExecutionStatus }) => {
  const style = EXECUTION_STEP_ICON_STYLES[statusMapping[status]] ?? FALLBACK_STYLE;

  return (
    <Stack className={cn("h-8 w-8 justify-center rounded-full border-2 border-solid", style.iconBgClassName)}>
      <Icon color={style.iconColor} iconName={STATUS_ICON_NAME[status] ?? FALLBACK_ICON_NAME} size="sm" />
    </Stack>
  );
};
